import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TUnkoKanrisyaInfoGetRes,
  TUnkoKanrisyaListGetReq,
  TUnkoKanrisyaPutReq,
} from "./TUnkoKanrisya"

/**
 * 運行管理者マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class UnkokanrisyaService
 * @extends {ConnectApi}
 */
export default class UnkokanrisyaService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TUnkoKanrisyaListGetReq} params
   * @param {(param: TApiResponse<TUnkoKanrisyaInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TUnkoKanrisyaInfoGetRes[]>) => any} reject
   * @memberof UnkokanrisyaService
   */
  getList = async (params: TUnkoKanrisyaListGetReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TUnkoKanrisyaInfoGetRes[]>> =
        await this.getInner(`/truckcontrol/unkokanrisya`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 一覧更新
   * @param data
   */
  putList = async (data: TUnkoKanrisyaPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<TUnkoKanrisyaInfoGetRes[]>> =
        await this.putInner(`/truckcontrol/unkokanrisya`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
